import React, { useState, useContext, Component, createRef } from "react";
import CartContext from "./CartContext";
import { BlobServiceClient } from "@azure/storage-blob";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import { LoadSpinner } from "./LoadSpinner";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Row, Col, Table, Form, Button } from "react-bootstrap";

export class RenewProduct extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      selectedLicensePeriod: 11,
      selectedRenewalMonths: 12,
      upgradeStatus: "",
    };
  }
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  GetSavingsAmount = () => {
    var sav = 0;

    var monthsSaved =
      this.state.selectedRenewalMonths === 12
        ? 1
        : this.state.selectedRenewalMonths === 24
        ? 3
        : this.state.selectedRenewalMonths === 36
        ? 6
        : 0;

    sav +=
      this.context.GetMonthlyCostOfStore(this.context.selectedProduct) *
      monthsSaved;

    sav += this.GetRenewalCostDiscount();

    return sav;
  };

  GetRenewalCost = () => {
    var months =
      this.state.selectedRenewalMonths === 12
        ? 11
        : this.state.selectedRenewalMonths === 24
        ? 21
        : this.state.selectedRenewalMonths === 36
        ? 30
        : this.state.selectedRenewalMonths;
    var result =
      this.context.GetMonthlyCostOfStore(this.context.selectedProduct) * months;

    return result;
  };

  GetRenewalCostDiscount = () => {
    return (this.GetRenewalCost() * 10) / 100;
  };

  GetRenewalCostToPay = () => {
    var yearly = this.GetRenewalCost() - this.GetRenewalCostDiscount();
    return (
      yearly +
      (yearly * Number(this.context.GetEcSettingValueByName("taxPercentage"))) /
        100
    );
  };

  GetNewRenewalDate = (months) => {
    if (new Date() < new Date(this.context.selectedProduct.storeEnd)) {
      var date1 = new Date(this.context.selectedProduct.storeEnd);
      var date2 = new Date(date1.setMonth(date1.getMonth() + months));
      return this.context.GetInDateFormat(date2);
    } else {
      var date1 = new Date();
      var date2 = new Date(date1.setMonth(date1.getMonth() + months));
      return this.context.GetInDateFormat(date2);
    }
  };

  CallRazorPay = async () => {
    var ordid = "order_" + new Date().getTime();
    var custName = "";
    var emailId = "";
    var mobileNo = "";

    if (this.context.userData.loginStatus === "active") {
      custName = this.context.userData.firstName;
      emailId = this.context.userData.emailId;
      mobileNo = this.context.userData.contactNo;
    }

    var result = await axios.post(
      process.env.REACT_APP_API +
        "sales/CreateRazorpayOrder/" +
        ordid +
        "/" +
        Math.round(this.GetRenewalCostToPay()) * 100
    );
    if (!result) {
      alert("Server error. Please try later");
      return;
    }

    var options = {
      key: this.context.GetEcSettingValueByName("razorpayKey"),
      key_secret: this.context.GetEcSettingValueByName("razorpayKeySecret"),
      // amount: 1 * 100,
      amount: Math.round(this.GetRenewalCostToPay()) * 100,
      currency: this.context.GetEcSettingValueByName("razorpayCurrency"),
      name: this.context.GetEcSettingValueByName("razorpayCompanyName"),
      description: this.context.GetEcSettingValueByName(
        "razorpayCompanyDescription"
      ),
      order_id: result.data.Attributes["id"],
      handler: (response) => {
        this.SuccessRazorPayResponse(ordid, response);
      },
      prefill: {
        name: custName, //customer name
        email: emailId, //customer emailId
        contact: mobileNo, //customer phoneno
      },
      notes: {
        address: this.context.GetEcSettingValueByName("razorpayCompanyAddress"),
      },
      theme: {
        color: this.context.GetEcSettingValueByName("razorpayThemeColor"),
      },
      modal: {
        escape: false,
        ondismiss: () => {
          this.context.UpdateOrderStatus("Dismissed");
        },
      },
    };
    var pay = window.Razorpay(options);
    //var rzp1 = new Razorpay(options);
    //pay.on("payment.failed", function (response) {
    pay.on("payment.failed", (response) => {
      this.FailedInRazorPayResponse(response);
    });
    pay.open();
  };
  FailedInRazorPayResponse = (response) => {
    this.context.UpdateOrderStatus("Failed");
  };
  SuccessRazorPayResponse = (orderId, response) => {
    this.SubmitOrder(orderId, response);
    console.log(response.razorpay_payment_id);
  };

  SubmitOrder = (orderId, response) => {
    this.ShowLoadSpinner();
    var str = {
      tenantId: this.context.userData.id,
      orderType: 3, //Renewal
      storeId: this.context.selectedProduct.id,
      licenseType: this.context.selectedProduct.storeTypeId,
      businessName: this.context.selectedProduct.name,
      productName: this.context.selectedProduct.name,
      LicenseMonths: this.state.selectedRenewalMonths,
      paidAmt: this.GetRenewalCostToPay(),
      paymentModeId: 1, //1 Razorpay --2 Bank Account

      //paymentTransactionId: razorpayTransactionId,
      razorpayOrderId: response.razorpay_order_id,
      razorpayPaymentId: response.razorpay_payment_id,
      razorpaySignature: response.razorpay_signature,
      paymentTransactionId: response.razorpay_payment_id,

      paymentStatusId: 1, //1 Paid 2 Unpaid 3 Partially Paid
      status: 3, //1 NewOrder 2 InProgress 3 Complete 4 Cancelled
    };
    axios
      .post(process.env.REACT_APP_API + "Sales/SubmitOrder", str)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            title: "",
            confirmButtonColor: "#23B14D",
            text: "Renewed Successfully!",
            confirmButtonText: "Ok",
          }).then((result) => {
            this.setState({ upgradeStatus: "Success" });
          });
          this.HideLoadSpinner();
        } else {
          alert("Failed. Please try later!");
          this.HideLoadSpinner();
        }
      })
      .catch((error) => {
        alert("Failed. Please try later!", error);
        this.HideLoadSpinner();
      });
  };

  handleSubmit = () => {
    this.CallRazorPay();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    if (this.context.userData.loginStatus !== "active")
      return <Navigate to="/home" />;
    if (this.state.upgradeStatus === "Success")
      return <Navigate to="/MyProducts" />;

    return (
      <>
        <div className="container py-3">
          {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

          <h2 className="pt-2 mb-3 text-primary text-center">
            Renewal of {this.context.selectedProduct.name}
          </h2>

          <Table bordered responsive>
            <thead>
              <tr className="text-center">
                <th>License Plan</th>
                <th>Total User Access</th>
                <th>Data Retention Period</th>
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) && <th>SEO & Independent Hosting</th>}
                <th>Monthly Cost</th>
                <th>Yearly Cost</th>
                <th>License Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <td>
                  {{
                    [this.context.LicenseType.FREE]: "Free",
                    [this.context.LicenseType.BASIC]: "Basic",
                    [this.context.LicenseType.STANDARD]: "Standard",
                    [this.context.LicenseType.PROFESSIONAL]: "Professional",
                    [this.context.LicenseType.ENTERPRISE]: "Enterprise",
                    [this.context.LicenseType.PREMIUM]: "Premium",
                    [this.context.LicenseType.CUSTOM]: "Custom",
                  }[this.context.selectedProduct.storeTypeId] || ""}
                </td>
                <td>{this.context.selectedProduct.totalUsers}</td>
                <td>
                  {this.context.selectedProduct.dataRetensionMonths} Months
                </td>
                {this.context.IsECommerceProduct(
                  this.context.selectedProduct.productTypeId
                ) && (
                  <td>
                    {this.context.selectedProduct.enableSeo ? "Yes" : "No"}
                  </td>
                )}
                <td>
                  {this.context
                    .GetMonthlyCostOfStore(this.context.selectedProduct)
                    .toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                      maximumFractionDigits: 0,
                    })}
                </td>
                <td>
                  {(
                    this.context.GetMonthlyCostOfStore(
                      this.context.selectedProduct
                    ) * 12
                  ).toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    maximumFractionDigits: 0,
                  })}
                </td>
                <td>
                  {this.context.GetInDateFormat(
                    new Date(this.context.selectedProduct.storeEnd)
                  )}
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="p-3 bg-light">
            {/* Renewal Tenure */}
            <Row className="mb-3">
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}>
                <b>Select Renewal Tenure</b>
              </Col>
              <Col xs={12} md={3}>
                <Form.Select
                  className="border text-start fw-bold fs-6"
                  plaintext
                  value={this.state.selectedLicensePeriod}
                  onChange={(e) => {
                    const val = parseInt(e.target.value);
                    this.setState({
                      selectedLicensePeriod: val,
                      selectedRenewalMonths:
                        val === 6 ? 6 : val === 11 ? 12 : val === 21 ? 24 : 36,
                    });
                  }}
                >
                  <option value={6}>6 Months</option>
                  <option value={11}>1 Year (get 1 month FREE)</option>
                  <option value={21}>2 years (get 3 months FREE)</option>
                  <option value={30}>3 Years (get 6 months FREE)</option>
                </Form.Select>
              </Col>
              <Col xs={12} md={3}></Col>
            </Row>

            {/* New Expiry Date */}
            <Row className="mb-3">
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}>
                <b>New expiry date after Renewal</b>
              </Col>
              <Col xs={12} md={3}>
                <b>
                  {this.GetNewRenewalDate(this.state.selectedRenewalMonths)}
                </b>
                <hr />
              </Col>
              <Col xs={12} md={3}></Col>
            </Row>

            {/* Renewal Cost */}
            {[
              ["Renewal Cost", this.GetRenewalCost()],
              ["Discount(10%)", this.GetRenewalCostDiscount()],
              [
                "Sub.Total",
                this.GetRenewalCost() - this.GetRenewalCostDiscount(),
              ],
              [
                "Tax (" +
                  Number(
                    this.context.GetEcSettingValueByName("taxPercentage")
                  ) +
                  "%)",
                ((this.GetRenewalCost() - this.GetRenewalCostDiscount()) *
                  Number(
                    this.context.GetEcSettingValueByName("taxPercentage")
                  )) /
                  100,
              ],
            ].map(([label, value], idx) => (
              <Row className="mb-3" key={idx}>
                <Col xs={12} md={3}></Col>
                <Col xs={12} md={3}>
                  <b>{label}</b>
                </Col>
                <Col xs={12} md={3}>
                  <b>
                    {value.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                      maximumFractionDigits: 0,
                    })}
                  </b>
                  <hr />
                </Col>
                <Col xs={12} md={3}></Col>
              </Row>
            ))}

            {/* Total Cost & Savings */}
            <Row className="mb-3">
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}>
                <b>Total Renewal Cost</b>
              </Col>
              <Col xs={12} md={3}>
                <h4>
                  {this.GetRenewalCostToPay().toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    maximumFractionDigits: 0,
                  })}
                </h4>
                <hr />
              </Col>
              <Col xs={12} md={3}></Col>
            </Row>

            <Row className="mb-3">
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}>
                <b>Total Savings</b>
              </Col>
              <Col xs={12} md={3}>
                <b>
                  {this.GetSavingsAmount().toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    maximumFractionDigits: 0,
                  })}
                </b>
                <hr />
              </Col>
              <Col xs={12} md={3}></Col>
            </Row>

            {/* Button */}
            <Row className="mb-3">
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}></Col>
              <Col xs={12} md={3}>
                <Button
                  className="w-100"
                  size="lg"
                  style={{ textTransform: "capitalize" }}
                  onClick={() => this.handleSubmit()}
                >
                  Renew & Pay{" "}
                  {this.GetRenewalCostToPay().toLocaleString("en-IN", {
                    style: "currency",
                    currency: "INR",
                    maximumFractionDigits: 0,
                  })}
                </Button>
              </Col>
              <Col xs={12} md={3}></Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}
